import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
export const Navigation = ({ items, selectedKey, mode = 'horizontal', className = '', onItemClick, }) => {
    const handleItemClick = (key) => {
        onItemClick?.(key);
    };
    const renderMenuItem = (item) => {
        if (item.children) {
            return (_jsxs(NavigationSubmenu, { className: "navigation-submenu", children: [_jsxs(SubmenuTitle, { className: "submenu-title", children: [item.label, _jsx(SubmenuArrow, { children: "\u25BC" })] }), _jsx(SubmenuContent, { className: "submenu-content", children: item.children.map((child) => (_jsx(SubmenuItem, { children: _jsx(NavigationLink, { to: child.path, onClick: () => handleItemClick(child.key), className: selectedKey === child.key ? 'active' : '', children: child.label }) }, child.key))) })] }, item.key));
        }
        return (_jsx(NavigationItem, { className: "navigation-item", children: _jsx(NavigationLink, { to: item.path, onClick: () => handleItemClick(item.key), className: selectedKey === item.key ? 'active' : '', children: item.label }) }, item.key));
    };
    return (_jsx(NavigationContainer, { mode: mode, className: `legarta-navigation legarta-navigation--${mode} ${className}`, children: items.map(renderMenuItem) }));
};
const NavigationContainer = styled.nav `
  display: flex;
  align-items: center;
  
  &.legarta-navigation--horizontal {
    flex-direction: row;
    
    .navigation-item {
      margin: 0 20px;
    }
    
    .navigation-submenu {
      margin: 0 20px;
    }
  }
  
  &.legarta-navigation--vertical {
    flex-direction: column;
    align-items: stretch;
    
    .navigation-item {
      margin: 0;
    }
    
    .navigation-submenu {
      margin: 0;
    }
  }
`;
const NavigationItem = styled.div `
  position: relative;
`;
const NavigationLink = styled(Link) `
  display: block;
  padding: 0;
  text-decoration: none;
  color: ${colors.textPrimary};
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  
  &:hover {
    color: ${colors.primary};
  }
  
  &:focus {
    outline: none;
    color: ${colors.primary};
  }
  
  &.active {
    color: ${colors.primary};
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      right: 0;
      height: 2px;
      background: ${colors.primary};
      border-radius: 1px;
    }
  }
`;
const NavigationSubmenu = styled.div `
  position: relative;
  
  &:hover .submenu-content {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;
const SubmenuTitle = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: ${colors.textPrimary};
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: ${colors.primary};
  }
  
  &:focus {
    outline: none;
    color: ${colors.primary};
  }
`;
const SubmenuArrow = styled.span `
  font-size: 10px;
  transition: transform 0.3s ease;
  
  .navigation-submenu:hover & {
    transform: rotate(180deg);
  }
`;
const SubmenuContent = styled.div `
  position: absolute;
  top: 100%;
  left: 0;
  background: ${colors.backgroundPrimary};
  border-radius: 8px;
  box-shadow: 0 4px 12px ${colors.shadowLight};
  min-width: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  
  .legarta-navigation--vertical & {
    position: static;
    box-shadow: none;
    min-width: auto;
    opacity: 1;
    visibility: visible;
    transform: none;
    margin-top: 8px;
    margin-left: 16px;
  }
`;
const SubmenuItem = styled.div `
  a {
    display: block;
    padding: 12px 20px;
    text-decoration: none;
    color: ${colors.textPrimary};
    font-weight: 500;
    transition: color 0.3s ease;
    
    &:hover {
      color: ${colors.primary};
      background: ${colors.backgroundLight};
    }
    
    &.active {
      color: ${colors.primary};
      background: ${colors.backgroundLight};
    }
  }
`;
